// extracted by mini-css-extract-plugin
export default {"root":"THVTr","transform":"xWknE","swipeable":"uZi-a","preview":"DlXwE","next":"hgmkh","prev":"_7DEY8","loading":"nk3K3"};